/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import Vue from 'vue';
import store from '../vuex/store';
import _ from 'lodash';

export const http = {};

function handlePromise(promise) {
  return promise
    .then(response => {
      return response.body.data;
    })
    .catch(response => {
      const errors = response.body && response.body.errors
        ? response.body.errors
        : [ { message: 'Network error' }]; // for status 0, 504
      errors.forEach(error => {
        error.$status = response.status;
      });
      if (response.status >= 500) {
        store.dispatch('notify', {
          type: 'error',
          subject: 'Oops! There was a problem.',
          text: 'Please try your request again'
        });
      } else if (response.status === 0) {
        store.dispatch('notify', {
          type: 'error',
          subject: 'Cannot connect to the internet',
          text: 'Please check that you are connected to the internet and try again'
        });
      }
      throw errors;
    });
}

_.forEach(['get', 'delete'], method => {
  const ongoingPromises = {};

  http[method] = (url, options) => {
    if (!ongoingPromises[url]) {
      ongoingPromises[url] = handlePromise(Vue.http[method](url, options))
        .catch(() => {
          return {}; // never need to raise a custom error in the UI
        })
        .finally(() => {
          delete ongoingPromises[url];
        });
    }
    return ongoingPromises[url];
  };
});

_.forEach(['post', 'put'], method => {

  http[method] = (url, body, options) => {
    store.dispatch('clearNotification');
    return handlePromise(Vue.http[method](url, body, options));
  };
});
